export default {
  'meta': {
    'langName': 'ARABIC',
    'lang': 'العربية'
  },
  'title': 'إسترداد  المنتج \nB900 BOX NBA BASKETBALL BASKET TARMAK',
  'description': 'لقد رصدنا خطر سقوط عمود حلقة كرة السلة B900 عموديًا في حال استخدامه بدون مقبضه.\nلسلامتكم، توقفوا فورًا عن استخدامه بدون تثبيت مقبض تعديل الارتفاع.\nيمكنكم تأمين منتجكم بإجراء بسيط ومجموعة أدوات سيتم توصيلها إليكم مجانًا.\nهذا الموقع الإلكتروني المخصص لهذا الاستدعاء قيد الإنشاء حاليًا، وسيرشدكم إلى الخطوات اللازمة.\nسنُعلمكم فور توفره (خلال شهر يوليو).',
  'status': 'Translation validated by COUNTRY'
} as const
